<template>
  <div class="adv">
    <img src="./resources/adv_img.jpg" alt="adv" srcset />
    <div class="title" :style="!isMobile || 'padding: 20px 0;'">
      <h1 class="tit" :style="!isMobile || 'font-size: 18px;'">{{ title }}</h1>
      <h4 class="subtitle" v-show="!isMobile">{{ subtitle }}</h4>
    </div>
  </div>
</template>

<script>
import { _isMobile } from '@/utils/config';

export default {
  name: 'adv',
  // 与父组件通信
  props: {
    title: { type: String, default: '未设置标题' },
    subtitle: { type: String, default: '未设置子标题' },
  },
  components: {},
  // 数据
  data() {
    return {
      bodyWidth: 0,
      isMobile: _isMobile(),
    };
  },
};
</script>
<style scoped lang="less">
@import './index.less';
</style>
